/* ==========================================================================
   TrendyBits · Navigation fix
   --------------------------------------------------------------------------
   Two jobs, both applied to the Categories AND Seasons mega menus (they share
   the same markup, rendered by the same generic block in sections/tb-header.liquid).

   1. CLICK-THROUGH.
      Each universe / season renders as a <button> whose only job is to swap
      the panel on the right. Hovering worked, clicking did nothing, and the
      only way through to the collection was the small "Shop all" link inside
      the panel. We upgrade each button into a real <a> pointing at the same
      URL that panel's "Shop all" CTA uses. Hover still swaps the panel, and
      because it is a real link it also supports middle click, cmd/ctrl click
      and "open in new tab".

   2. ICONS.
      The header picks the little icon purely from the item's POSITION in the
      list (index modulo 8), so the Seasons menu inherited the Categories
      emoji set — Eid showed a ramen bowl, Christmas a superhero, Valentine a
      football. We re-pick the icon from the destination collection instead:

        a) if that collection has an image set in Shopify admin, we show the
           image  (this is the "photo instead of the emoji" control — upload a
           collection image and it appears here automatically, no code);
        b) else a hand-picked emoji matched on the collection handle;
        c) else leave whatever the header rendered.

      The image lookup table is emitted by snippets/meta-tags.liquid into
      <script id="tb-nav-icons">, one "handle|url" pair per line.

   Loaded from snippets/meta-tags.liquid. Removing that one line disables all
   of the above with no side effects — sections/tb-header.liquid is untouched.
   ========================================================================== */
(function () {
  'use strict';

  /* --- icon fallbacks, matched on the collection handle -------------------
     Exact handles first, then loose keyword matching so a renamed handle
     still lands on something sensible. */
  var EXACT = {
    'animeverse': '🍜',
    'fanverse': '🦸',
    'gameverse': '🎮',
    'customizable': '🛠️',
    'gadgetgang': '🎧',
    'carverse': '🚗',
    'bookmarks': '📚',
    'quackverse': '🦆',
    'eid': '🕌',
    'ramadan': '🌙',
    'christmas-1': '🎄',
    'mothers-day': '💐',
    'back-to-school': '🎒',
    'valentine': '💝',
    'summer-offers': '☀️'
  };

  var KEYWORDS = [
    ['anime', '🍜'], ['fan', '🦸'], ['game', '🎮'], ['custom', '🛠️'],
    ['gadget', '🎧'], ['car', '🚗'], ['book', '📚'], ['quack', '🦆'],
    ['eid', '🕌'], ['ramadan', '🌙'], ['christmas', '🎄'], ['xmas', '🎄'],
    ['mother', '💐'], ['father', '👔'], ['school', '🎒'], ['graduat', '🎓'],
    ['valentine', '💝'], ['love', '💝'], ['summer', '☀️'], ['winter', '❄️'],
    ['spring', '🌸'], ['autumn', '🍂'], ['fall', '🍂'], ['halloween', '🎃'],
    ['black-friday', '🏷️'], ['friday', '🏷️'], ['new-year', '🎆'],
    ['birthday', '🎂'], ['ramad', '🌙'], ['sale', '🏷️'], ['deal', '🔥'],
    ['new', '✨'], ['gift', '🎁']
  ];

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* handle → image url, from the block meta-tags.liquid prints */
  function iconMap() {
    var map = {};
    var el = document.getElementById('tb-nav-icons');
    if (!el) return map;
    var lines = (el.textContent || '').split('\n');
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i].trim();
      if (!line) continue;
      var cut = line.indexOf('|');
      if (cut < 1) continue;
      map[line.slice(0, cut)] = line.slice(cut + 1);
    }
    return map;
  }

  function handleFromHref(href) {
    if (!href) return '';
    var path = href.split('?')[0].split('#')[0];
    var cut = path.indexOf('/collections/');
    if (cut === -1) return '';
    var rest = path.slice(cut + 13);
    /* /collections/foo/bar → foo */
    return rest.split('/')[0].toLowerCase();
  }

  function emojiFor(handle) {
    if (!handle) return '';
    if (EXACT[handle]) return EXACT[handle];
    for (var i = 0; i < KEYWORDS.length; i++) {
      if (handle.indexOf(KEYWORDS[i][0]) !== -1) return KEYWORDS[i][1];
    }
    return '';
  }

  /* Replace the index-derived icon with one that belongs to this collection. */
  function fixIcon(el, handle, images) {
    var slot = el.querySelector('.tb-cat-nav__emoji');
    if (!slot || !handle) return;

    var src = images[handle];
    if (src) {
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.width = 22;
      img.height = 22;
      img.loading = 'lazy';
      img.className = 'tb-cat-nav__icon-img';
      slot.textContent = '';
      slot.appendChild(img);
      return;
    }

    var emoji = emojiFor(handle);
    if (emoji) slot.textContent = emoji;
  }

  /* Re-implements the panel switching that tb-header.liquid binds to the
     original buttons. We need our own copy because replacing the node drops
     the listener the header already attached. */
  function activate(el) {
    var target = el.getAttribute('data-tb-cat-target');
    var nav = el.closest('[data-tb-cat-nav]');
    var mega = el.closest('.tb-mega--categories');
    if (!target || !nav || !mega) return;

    var i;
    var sibs = nav.querySelectorAll('.tb-cat-nav__btn');
    for (i = 0; i < sibs.length; i++) sibs[i].classList.remove('is-active');
    el.classList.add('is-active');

    var panels = mega.querySelectorAll('[data-tb-cat-panel]');
    for (i = 0; i < panels.length; i++) {
      panels[i].classList.remove('is-active');
      if (panels[i].getAttribute('data-tb-cat-panel') === target) {
        panels[i].classList.add('is-active');
      }
    }
  }

  function hrefForTarget(mega, target) {
    var panel = mega.querySelector('[data-tb-cat-panel="' + target + '"]');
    if (!panel) return '';
    /* the panel head carries the canonical "Shop all" link for that universe */
    var cta = panel.querySelector('.tb-cat-panel__cta');
    var href = cta ? cta.getAttribute('href') : '';
    if (!href || href === '#') return '';
    return href;
  }

  function upgrade() {
    var images = iconMap();
    var btns = document.querySelectorAll('button.tb-cat-nav__btn[data-tb-cat-target]');
    if (!btns.length) return;

    Array.prototype.forEach.call(btns, function (btn) {
      var mega = btn.closest('.tb-mega--categories');
      if (!mega) return;

      var target = btn.getAttribute('data-tb-cat-target');
      var href = hrefForTarget(mega, target);
      var handle = handleFromHref(href);

      /* No usable destination — keep the button exactly as it was rather than
         creating a dead link, but still correct its icon if we can. */
      if (!href) {
        fixIcon(btn, handle, images);
        return;
      }

      var a = document.createElement('a');
      a.href = href;
      a.className = btn.className;
      a.setAttribute('data-tb-cat-target', target);
      a.setAttribute('data-tb-cat-link', '');
      if (btn.getAttribute('style')) a.setAttribute('style', btn.getAttribute('style'));
      a.style.textDecoration = 'none';
      a.innerHTML = btn.innerHTML;

      fixIcon(a, handle, images);

      btn.parentNode.replaceChild(a, btn);

      a.addEventListener('mouseenter', function () { activate(a); });
      a.addEventListener('focus', function () { activate(a); });
    });
  }

  ready(function () {
    try {
      upgrade();
    } catch (e) {
      if (window.console) console.warn('[tb-nav-fix]', e);
    }
  });
})();
